<template>
  <b-modal
    id="editTemplate"
    ref="editTemplate"
    size="xl"
    :title="modalTitle"
    hide-footer
    no-enforce-focus
    @hide="hideModal"
  >
    <div class="template-container">
      <div class="template-layout">
        <!-- Left side: Form -->
        <div class="form-section">
          <form>
            <div class="form-group mb-3 row">
              <label for="title" class="col-sm-3 col-form-label font-weight-500">テンプレート名（必須）</label>
              <div class="col-sm-9">
                <input
                  class="form-control custom-input"
                  type="text"
                  data-vv-as="テンプレート名"
                  placeholder="任意のテンプレート名を入力してください"
                  id="title"
                  v-validate="'required'"
                  name="Name"
                  v-model="name"
                />
                <div class="error">
                  <FieldError :message="$validator.errors.first('Name')" />
                </div>
              </div>
            </div>

            <div class="form-group mb-3 row">
              <label for="contactType" class="col-sm-3 col-form-label font-weight-500">スカウト形式（必須）</label>
              <div class="col-sm-9 radio-labels">
                <div class="radio-options-container">
                  <div class="radio-options-main">
                    <label class="me-2">
                      <input type="radio" name="contactType" value="応募案内" v-model="contactType" />
                      応募案内
                    </label>
                    <label class="me-2">
                      <input type="radio" name="contactType" value="カジュアル面談" v-model="contactType" />
                      カジュアル面談
                    </label>
                    <label class="me-2">
                      <input type="radio" name="contactType" value="面接案内" v-model="contactType" />
                      面接案内
                    </label>
                  </div>
                  <div class="radio-options-notification">
                    <label>
                      <input type="radio" name="contactType" value="その他通知" v-model="contactType" />
                      通知のみ
                    </label>
                  </div>
                </div>
                <div class="notification-disclaimer">
                  <small class="text-muted">※通知のみは、求人添付および登録者からの回答受付はできません。</small>
                </div>
              </div>
            </div>

            <div class="form-group mb-3 row">
              <label for="jd_title" class="col-sm-3 col-form-label font-weight-500">添付求人</label>
              <div class="col-sm-9">
                <input
                  class="form-control custom-input"
                  type="text"
                  data-vv-as="スカウトする求人名"
                  placeholder="スカウトする求人をシステムから選択する際はパラメータを入力してください"
                  id="jd_title"
                  name="jd_title"
                  v-model="jd_title"
                />
                <div class="error">
                  <FieldError :message="$validator.errors.first('JobTitle')" />
                </div>
              </div>
            </div>

            <div class="form-group mb-3 row">
              <label for="sender" class="col-sm-3 col-form-label font-weight-500">差出人名</label>
              <div class="col-sm-9">
                <input
                  class="form-control custom-input"
                  type="text"
                  data-vv-as="送信者名"
                  placeholder="スカウトの差出人として表示するお名前を入力してください"
                  id="sender"
                  name="Sender"
                  v-model="sender"
                />
                <div class="error">
                  <FieldError :message="$validator.errors.first('Sender')" />
                </div>
              </div>
            </div>

            <div class="form-group mb-3 row">
              <label for="subject" class="col-sm-3 col-form-label font-weight-500">件名（必須）</label>
              <div class="col-sm-9">
                <input
                  class="form-control custom-input"
                  type="text"
                  data-vv-as="件名"
                  id="subject"
                  v-validate="'required'"
                  name="Subject"
                  v-model="subject"
                />
                <div class="error">
                  <FieldError :message="$validator.errors.first('Subject')" />
                </div>
              </div>
            </div>

            <div class="form-group mb-3 row">
              <label for="code" class="col-sm-3 col-form-label font-weight-500">本文(必須)</label>
              <div class="col-sm-9">
                <TiptapEditor
                  v-if="showEditTemplateModal"
                  placeholder="Enter Message Body"
                  v-model="message_body"
                />
                <div class="error">
                  <FieldError :message="$validator.errors.first('MessageBody')" />
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- Right side: Parameters -->
        <div class="parameters-section">
          <div class="param-value">
            <span class="font-bold">テンプレートに利用可能なパラメータ</span><br /><br />
            スカウトする登録者の苗字：<br />
            %jobseeker.last_name%<br /><br />
            添付するスカウト求人のタイトル：<br />
            %selected_jd_title%<br /><br />
            貴社名：<br />
            %company%<br /><br />
            送信者名：<br />
            %user_name%<br /><br />
            選択したJD詳細：<br />
            %selected_jd_detail%<br /><br />
            選択したJD要件：<br />
            %selected_jd_qualification%<br /><br />
            選択したJD勤務地：<br />
            %selected_jd_location%<br /><br />
            選択したJD年収：<br />
            %selected_jd_salary%
          </div>
        </div>
      </div>

      <!-- Buttons centered below both sections -->
      <div class="form-actions">
        <button
          v-if="editModalData"
          class="btn btn-saveas me-3 btn-action"
          type="button"
          :disabled="isSubmitting"
          @click.prevent="submitAction"
        >
          別名で保存
        </button>
        <button
          v-if="!editModalData"
          class="btn btn-cancel me-3 btn-action"
          type="reset"
          @click.prevent="reset"
        >
          キャンセル
        </button>
        <button
          class="btn btn-create btn-action"
          type="submit"
          :disabled="isSubmitting"
          @click.prevent="editModalData ? overwriteSave() : submitAction()"
        >
          {{ editModalData ? '上書き保存' : '新規作成' }}
        </button>
      </div>
    </div>

    <MessageTemplateModal
        @hide-modal="onHideModal"
        @rowSelected="onTemplateSelected"
        v-if="showMessageTemplateModal"
      />
    </div>
  </b-modal>
</template>

<script>
import DOMPurify from 'dompurify';
import { mapActions, mapGetters } from 'vuex';
import TiptapEditor from '../../../utils/TiptapEditor.vue';
import FieldError from '../../../utils/FieldError.vue';
import MessageTemplateModal from './MessageTemplateModal.vue';
import ApiService from '@/service/apiService';
import API from '@/config/api';

export default {
  name: 'EditMessageTemplate',
  components: {
    TiptapEditor,
    FieldError,
    MessageTemplateModal,
  },
  props: {
    id: String | undefined,
    editModalData: Object | undefined,
    page_title: String,
    showEditTemplateModal: Boolean,
    isReplyTemplate: Boolean | false,
  },
  data() {
    return {
      name: '',
      subject: '',
      message_body: '',
      jd_url: '',
      jd_title: '',
      questionRequest: false,
      contactType: '応募案内',
      sender: '',
      jdDisplay: false,
      isMessageValid: false,
      isDisabled: false,
      showMessageTemplateModal: false,
      selectedTemplate: undefined,
      parameters: {
        貴社名: '%company%',
        送信者名: '%user_name%',
        '登録ユーザー名(姓)': '%jobseeker.last_name%',
        '選択したJDタイトル(ポジション名)': '%selected_jd_title%',
        選択したJD詳細: '%selected_jd_detail%',
        選択したJD要件: '%selected_jd_qualification%',
        選択したJD勤務地: '%selected_jd_location%',
        選択したJD年収: '%selected_jd_salary%',
      },
      isSubmitting: false,
    };
  },
  methods: {
    ...mapActions([
      'loadAllMessageTemplates',
      'getOrLoadMessageTemplates',
      'addFlashMessages',
      'removeAllFlashMessages',
      'removeFlashMessage',
    ]),
    clearForm() {
      this.message_body = '';
    },
    show() {
      this.$refs.editTemplate.show();
    },
    hideModal() {
      this.$emit('close');
      this.clearForm();
      this.$refs.editTemplate.hide();
    },
    openMessageTemplateModal() {
      this.showMessageTemplateModal = true;
    },
    onHideModal() {
      this.showMessageTemplateModal = false;
    },
    async onTemplateSelected(id) {
      this.selectedTemplate = undefined;
      let allTemplates = await this.getOrLoadMessageTemplates();
      this.selectedTemplate = allTemplates.find(
        (template) => template._id === id
      );
      // console.log(this.selectedTemplate);
      window.scrollTo(0, 0);
      this.onHideModal();
    },
    async submit(saveAsnew = false) {
      this.isDisabled = true;
      let isOk = await this.$validator.validate();

      this.validateMessageBody();

      // Additional validation for required fields
      let validationErrors = [];
      
      if (!this.name || !this.name.trim()) {
        validationErrors.push('テンプレート名は必須項目です');
        this.$validator.errors.add({
          field: 'Name',
          msg: 'テンプレート名は必須項目です',
        });
      }
      
      if (!this.contactType) {
        validationErrors.push('スカウト形式は必須項目です');
      }
      
      if (!this.subject || !this.subject.trim()) {
        validationErrors.push('件名は必須項目です');
        this.$validator.errors.add({
          field: 'Subject',
          msg: '件名は必須項目です',
        });
      }

      if (!isOk || !this.isMessageValid || validationErrors.length > 0) {
        let element = document.getElementsByClassName('is-invalid ')[0];
        if (element) {
          element.scrollIntoView();
        }
        if (!this.isMessageValid) {
          this.$validator.errors.add({
            field: 'MessageBody',
            msg: '本文は必須項目です',
          });
        }
        
        // Show error message
        if (validationErrors.length > 0) {
          this.removeAllFlashMessages();
          this.addFlashMessages([
            { message: '入力内容に誤りがあります。赤字の項目をご確認ください。', type: 'danger' }
          ]);
          setTimeout(() => {
            this.removeAllFlashMessages();
          }, 5000);
        }
      } else {
        // Check for duplicate template name when saving as new or creating new
        if (saveAsnew || !this.editModalData) {
          const allTemplates = await this.getOrLoadMessageTemplates();
          const duplicateTemplate = allTemplates.find(
            template => template.name.toLowerCase() === this.name.trim().toLowerCase() &&
            template._id !== (this.editModalData ? this.editModalData._id : null)
          );
          
          if (duplicateTemplate) {
            this.addFlashMessages([
              { message: 'このテンプレート名は既に存在します', type: 'danger' }
            ]);
            setTimeout(() => {
              this.removeAllFlashMessages();
            }, 5000);
            this.isDisabled = false;
            return;
          }
        }
        
        // scroll to top
        // window.scrollTo(0, 0);
        const messageBody = DOMPurify.sanitize(this.message_body, {
          ADD_ATTR: ['target'],
        });
        // if (this.isReplyTemplate) {
        //   this.contactType = 'その他通知';
        // }
        const payload = {
          name: this.name,
          subject: this.subject,
          message_body: messageBody,
          job_title: this.jd_title,
          job_url: this.jd_url,
          contact_type: this.contactType,
          question_request: this.questionRequest,
          sender: this.sender,
          jd_display: this.jdDisplay,
          // is_reply_template: this.isReplyTemplate,
          // id: this.editModalData.id,
        };
        this.submitHandler(payload, saveAsnew);
        // this.$emit("custom:submit", {
        //   name: this.name,
        //   subject: this.subject,
        //   message_body: messageBody,
        //   job_title: this.jd_title,
        //   job_url: this.jd_url,
        //   contact_type: this.contactType,
        //   question_request: this.questionRequest,
        //   sender: this.sender,
        //   jd_display: this.jdDisplay,
        //   id: this.id
        // })
      }
      this.isDisabled = false;
    },
    async submitHandler(payload, saveAsnew) {
      try {
        this.isSubmitting = true;
        let res;
        if (this.editModalData && !saveAsnew) {
          let editPayload = { ...payload, id: this.editModalData._id };
          res = await ApiService.put(
            API.endpoints.EDIT_MESSAGE_TEMPLATE(editPayload.id),
            editPayload
          );
        } else {
          res = await ApiService.post(
            API.endpoints.ADD_MESSAGE_TEMPLATE,
            payload
          );
        }

        // Clear existing messages before adding new ones
        this.removeAllFlashMessages();
        this.addFlashMessages([
          { message: res.data.data.success, type: 'success' },
        ]);
        setTimeout(() => {
          this.removeAllFlashMessages();
        }, 5000);
        await this.loadAllMessageTemplates();
        this.hideModal();
      } catch (err) {
        console.log(err);
        this.isSubmitting = false;
        this.errors = [];
        let messages = [];

        this.parseErrorResponse(err.response);
        let error = this.errors[0];
        for (let key of Object.keys(error)) {
          messages.push({ message: error[key].msg, type: 'danger' });
        }

        // Clear existing messages before adding new ones
        this.removeAllFlashMessages();
        // this.addFlashMessages([...messages]);
        setTimeout(() => {
          this.removeAllFlashMessages();
        }, 5000);
      } finally {
        this.isSubmitting = false;
      }
    },
    reset() {
      if (this.editModalData) {
        this.submit();
      } else {
        this.hideModal();
      }
      // this.$router.push({name: "message-template"});
    },
    submitAction() {
      this.submit(true);
    },
    overwriteSave() {
      this.submit(false);
    },
    validateMessageBody() {
      // this.isMessageValid = this.message_body.trim() !== '';
      const bodyContentMatch = this.message_body.match(
        /<body[^>]*>[\s\S]*<\/body>/i
      );
      const bodyContent = bodyContentMatch ? bodyContentMatch[0] : '';
      // Example validation: Check if the extracted content is not empty
      const userEnteredContent = bodyContent
        .replace(/<\/?[^>]+(>|$)/g, '')
        .trim();

      const content2 = this.message_body.replace(/<\/?[^>]+(>|$)/g, '').trim();

      this.isMessageValid = content2 || userEnteredContent !== '';

      // this.isMessageValid = userEnteredContent !== '';
    },
  },
  computed: {
    ...mapGetters(['getAllFlashMessages']),
    isOtherNotifications() {
      return this.contactType === 'その他通知';
    },
    modalTitle() {
      return this.editModalData
        ? 'テンプレート編集'
        : 'テンプレート新規作成';
    }
  },
  mounted() {
    this.$refs.editTemplate.show();
    if (this.editModalData) {
      const editModalData = this.editModalData;
      this.name = editModalData.name;
      this.subject = editModalData.subject;
      this.message_body = editModalData.body;
      this.jd_url = editModalData.job_url;
      this.jd_title = editModalData.job_title;
      this.sender = editModalData.sender;
      this.contactType = editModalData.contact_type
        ? editModalData.contact_type
        : '応募案内';
      this.questionRequest = editModalData.question_request
        ? editModalData.question_request
        : 'false';
      this.jdDisplay = editModalData.jd_display
        ? editModalData.jd_display
        : false;
    }
  },
  // async created() {
  //   if (this.id) {
  //     let allTemplate = await this.getOrLoadMessageTemplates();
  //     let template = allTemplate.find(template => this.id === template._id);

  //     if (template) {
  //       this.name = template.name;
  //       this.subject = template.subject;
  //       this.message_body = template.body;
  //       this.jd_url = template.job_url;
  //       this.jd_title = template.job_title;
  //       this.sender = template.sender;
  //       this.contactType = template.contact_type ? template.contact_type : '応募案内';
  //       this.questionRequest = template.question_request ? template.question_request : 'false';
  //       this.jdDisplay = template.jd_display ? template.jd_display : false;
  //     } else {
  //       this.addFlashMessages([{message: "テンプレートはありません。", type: "danger"}]);
  //       setTimeout(() => {
  //         this.$router.push({name: "message-template"});
  //         this.removeAllFlashMessages()
  //       }, 800)
  //     }
  //   }
  // },
  watch: {
    message_body: {
      handler() {
        this.validateMessageBody();
      },
      deep: true,
    },
    contactType(newVal) {
      if (newVal === 'その他通知') {
        this.questionRequest = false;
      }
    },
    // selectedTemplate: {
    //     handler(newTemplate){
    //         this.name = newTemplate ? newTemplate.name : '';
    //         this.subject = newTemplate ? newTemplate.subject : '';
    //         this.message_body = newTemplate ? newTemplate.body : '';
    //         this.jd_title = newTemplate ? newTemplate.job_title : '';
    //         this.jd_url = newTemplate ? newTemplate.job_url : '';
    //         this.contactType = newTemplate && newTemplate.contact_type ? newTemplate.contact_type : '応募案内';
    //         this.questionRequest = newTemplate ? newTemplate.question_request: 'false';
    //         this.sender = newTemplate ? newTemplate.sender: '';
    //         this.jdDisplay = newTemplate ? newTemplate.jd_display: false;
    //     },
    //     immediate:true
    // },
  },
};
</script>

<style scoped>
>>> .modal-xl {
  max-width: 85vw;
}

>>> .modal-header {
  border-bottom: none;
}

.template-container {
  padding: 0 20px;
}

.template-layout {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.form-section {
  flex: 0 0 70%;
  max-width: 70%;
}

.parameters-section {
  flex: 0 0 25%;
  max-width: 25%;
  padding-left: 20px;
}

.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding: 20px;
}

.btn-action {
  min-width: 165px;
  height: 50px;
  border-radius: 30px;
  padding: 6px;
}

.font-bold {
  font-weight: bold;
}

.form-group input[type='radio'] {
  flex: 3 !important;
  width: 25px !important;
  height: 25px;
  vertical-align: middle;
}

.radio-labels {
  color: #617776;
}

.radio-options-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 8px;
}

.radio-options-main {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.radio-options-notification {
  display: flex;
}

.notification-disclaimer {
  margin-top: 4px;
  padding-left: 350px;
}

@media (max-width: 768px) {
  .radio-options-container {
    flex-direction: column;
  }
  
  .radio-options-main {
    flex-direction: column;
  }
  
  .radio-options-main label {
    margin-right: 0 !important;
  }
}

.font-weight-500 {
  font-weight: 500;
}

.custom-input {
  border-radius: 2px;
  font-size: 0.9rem;
  color: black;
}

label {
  color: rgb(35, 35, 35);
}

.param-value {
  color: #000000;
  font-size: 12px;
  line-height: 1.5;
}

.form-group {
  margin-bottom: 1rem !important;
}

.custom-input:focus {
  box-shadow: none;
  border-color: #036d6c !important;
}

.is-valid {
  background: none !important;
  border-color: #ced4da !important;
}

.is-invalid {
  background: none !important;
}

input[type='checkbox'] {
  width: 25px;
  height: 25px;
}

.error > div {
  display: flex;
  justify-content: flex-end;
}

.btn-cancel {
  background-color: #797978 !important;
  color: #fff !important;
  border: none !important;
}

.btn-cancel:hover {
  background-color: #666 !important;
}

.btn-saveas {
  background-color: #019d9f !important;
  color: #fff !important;
  border: none !important;
}

.btn-saveas:hover {
  background-color: #017f81 !important;
}

.btn-create {
  background-color: #006c6b !important;
  color: #fff !important;
  border: none !important;
}

.btn-create:hover {
  background-color: #005555 !important;
}
</style>
